import { SofaFormFilter } from '@sofology/sofologycomponents';
import { format, isDate } from 'date-fns';

export const toStringFilter = (): SofaFormFilter<string> => (value: string) =>
    (isEmpty(value) ? '' : value.toString());

export const toNullableNumberFilter = (): SofaFormFilter<number | null> => (value: string) => {
    if (isEmpty(value)) {
        return null;
    }

    return Number(value);
};

export const stringToNullableNumberFilter = (): SofaFormFilter<number | null> => (value: string | number | null | undefined) =>
    (typeof value === 'number' ? value : (isEmpty(value) ? null : Number(value)));

export const toNullableString = (dateFormat: string): SofaFormFilter<string | null> => (value: Date | string | null) => {
    if (isEmpty(value)) {
        return null;
    }

    const date = new Date(value as string);

    if (isDate(date)) {
        return format(date, dateFormat);
    }

    return null;
};

const isEmpty = (value: string | Date | undefined | null): boolean =>
    value === undefined || value === null || value === '';